<template>
	<form class="partial auth-select" @submit.prevent.stop="submitForm(fields)">
		<div class="form-section" v-if="customerOptions?.length">
			<div class="form-section__description">Select which firm to access.</div>
			<div class="form-row">
				<SelectField v-model="fields.customerId" :options="customerOptions" label="Select Firm" class="form__field"></SelectField>
			</div>
		</div>
		<div class="form__message" v-else>
			You are not currently assigned to any firms. Please contact us if this seems like a mistake.
		</div>

		<div class="form__message error" v-if="errorMessage">
			{{ errorMessage }}
		</div>

		<div class="form__actions" v-if="customerOptions?.length">
			<Button look="form" type="submit" :disabled="isLoading" :loading="isLoading">Select</Button>
		</div>
	</form>
</template>

<script>
import { useHead } from '@unhead/vue'
import { useMeStore } from '@/lib/store/me'
import { useUserStore } from '@/lib/store/user'

import Button from '@/components/Button.vue'
import Card from '@/components/Card.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import SelectField from '@/components/SelectField.vue'


export default {
	name: 'AuthSelect',
	components: {
		Button,
		SelectField,
	},
	setup() {
		useHead({
			title: `Select Firm`
		})

		return {
			meStore: useMeStore(),
			userStore: useUserStore(),
		}
	},
	computed: {
		authData() {
			return this.userStore.authData
		},
		isLoading() {
			return this.userStore.isLoading
		},
		customerOptions() {
			return this.customers?.map(o => ({
				value: o.customerId,
				label: o.company,
			}))
		},
	},
	data: () => ({
		fields: {},
		errorMessage: null,
		customers: [],
	}),
	mounted() {
		if (!this.authData?.options) {
			this.meStore.getMe()
				.then(res => {
					this.customers = []
					for (const [customerId, value] of Object.entries(res?.customers || {})) {
						this.customers.push({
							customerId,
							...value,
						})
					}
				})
		} else {
			this.customers = this.authData.options
		}
	},
	methods: {
		submitForm(fields) {
			this.errorMessage = null
			this.userStore.authSelect(fields)
				.then(() => {
					this.$router.push({ name: 'calculator' })
				})
				.catch(error => {
					this.errorMessage = error.message || error
				})
		},
	},
}
</script>

<style scoped lang="scss">
.auth-select {
	max-width: 450px;
}
</style>
